export const enum DomInjectionType {
    HEAD_FIRST,
    HEAD_APPEND,
    BODY_FIRST,
    BODY_APPEND
}
